export default __webpack_public_path__ + "static/media/Ellipse 117.bf8a43e0.svg";